import { listField } from "./config";
import component from "./NotConfiguredPayout.vue";

export default {
  component,
  listField,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "not_configured";
};
